<button class="btn btn-success btn-icon-sm mr-2" (click)="onSearch()" [disabled]="loading || disabledButton">
    <i [ngClass]="(loading && clicked) ? 'spinner-border spinner-border-sm align-middle' : 'fas fa-search'"></i>Search
</button>
